<template>
  <div class="box">
    <div class="main">
      <!-- <div class="display step">
        <div class="display active">
          <div class="num">1</div>
          <div class="title">输入信息</div>
        </div>
        <div class="line"></div>
        <div class="display">
          <div class="num">2</div>
          <div>人脸核身</div>
        </div>
        <div class="line"></div>
        <div class="display">
          <div class="num">3</div>
          <div>操作完成</div>
        </div>
      </div> -->
      <van-steps :active="active">
        <van-step>输入信息</van-step>
        <!-- <van-step>人脸核身</van-step> -->
        <van-step>操作完成</van-step>
      </van-steps>
      <div class="for" v-if="infor">
        <div class="people">
          <i
            class="iconfont1 icon-user-wait"
            style="font-size:17px;padding-right:3px;color:rgb(28,127,253)"
          ></i>
          <span>就诊人：</span>
          {{ infor.patientName }}
        </div>
        <div class="information">
          <span>证件类型：</span>
          {{ infor.documentType }}
        </div>
        <div class="information">
          <span>证件号码：</span>
          {{ infor.idCard }}
        </div>
        <div class="information">
          <span>手机号码：</span>
          {{ infor.phoneNumber }}
        </div>

        <!-- <div class="information">
          <span>就诊卡号：</span>
          {{ infor.num }}
        </div> -->
      </div>
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="small" @click="goList"
        >完成</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'bindPatient',
  data() {
    return {
      active: 1,
      infor: {}
    }
  },
  created() {},
  mounted() {
    this.infor = JSON.parse(this.$route.query.commit)
  },
  methods: {
    onClickLeft() {},
    goList() {
      if (this.$route.query.selectQuery) {
        console.log(this.$route.query.selectQuery)
        let query = JSON.parse(this.$route.query.selectQuery)
        // this.$router.push({
        //   name: 'patientList',
        //   query: query
        // })
        this.$router.push('patientList')
      } else {
        this.$router.push('index')
      }
    }
  }
}
</script>
<style scoped>
.main /deep/ .van-step--finish .van-step__circle {
  background-color: #3478f7;
}

.main /deep/ .van-step--finish .van-step__line {
  background-color: #3478f7;
}

.main /deep/ .van-step__icon--active {
  color: #3478f7 !important;
  font-size: 16px;
}

.main /deep/ .van-step__title--active {
  color: #3478f7 !important;
  font-size: 16px;
}

.main /deep/ .van-step__title {
  font-size: 16px;
}

.main /deep/ .van-button--mini {
  font-size: 16px;
}

.box {
  width: 100vw;
  height: 100vh;
  background-color: rgb(242, 248, 253);
}

.main {
  font-size: 14px;
}

.step {
  background-color: #ffffff;
  border-top: 1px solid rgb(192, 233, 245);
  padding: 10px 0px;
}

.display {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
}

.num {
  border-radius: 100px;
  width: 17px;
  height: 17px;
  text-align: center;
  line-height: 17px;
  background-color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
  color: rgb(112, 112, 112);
  margin-right: 3px;
}

.line {
  width: 40px;
  margin: 0px 10px;
  height: 1px;
  background-color: rgb(198, 198, 198);
}

.active .num {
  background-color: rgb(8, 112, 253);
  color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
}

.active .title {
  color: rgb(8, 112, 253);
}

.active .num {
  background-color: rgb(8, 112, 253);
  color: #ffffff;
  border: 1px solid rgb(112, 112, 112);
}

.active .title {
  color: rgb(8, 112, 253);
}

.people {
  font-size: 18px;
  border-bottom: 1px solid rgb(240, 240, 240);
  padding: 10px 16px;
  color: #323233;
}

.people i {
  position: relative;
  top: 2px;
}

.people span {
  color: #969799;
}

.for {
  border-top: 1px solid rgb(234, 234, 235);
  background-color: #ffffff;
  padding-bottom: 10px;
}

.information {
  font-size: 18px;
  color: #323233;
  padding: 10px 10px 0px 16px;
}

.information span {
  color: #969799;
}

.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}

.footer button {
  width: calc(100% - 40px);
  height: 48px;
  margin: 10px 20px 10px 20px;
  font-size: 18px;
}

@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}
</style>
